import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "panel__scroll" }

import TimesSvg from '../assets/times.svg';

// Components
import VButton from './VButton.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'VPanel',
  setup(__props) {

// Svg

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VButton, {
      class: "button--rounded button--transparent panel__button panel__button--close",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(TimesSvg))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})